import { ThemeUIElementSettings } from '@frontend/casino-ui/shared';

export const themeScrollbarUISettings: ThemeUIElementSettings = {
    'bwin': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'coral': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'gala-casino-2': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'party-poker': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'mgm-4': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'ladbrokes': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'ladbrokes-de': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'foxy-games-3': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'gala-bingo-3': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'wheel-of-fortune': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'party-casino': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'party-casino-2': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'vistabet': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'premium': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'foxy-bingo-5': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'giocodigitale': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'slotclub': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
    'gamebookers': {
        scrollbar: {
            egv: { isInverse: true },
        },
    },
};
